var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [
      _vm._v(
        _vm._s(
          _vm.$t("notification.webAppDeleted", {
            actor: _vm.$_.get(_vm.activity, "actorUser.name"),
            appName: _vm.$_.get(_vm.activity, "payload.appName"),
            appSlug: _vm.$_.get(_vm.activity, "payload.appSlug"),
          })
        )
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }